import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getCourses,
  addReuestInfo,
  addReuestInfoSuccess,
} from "../redux/actions/common.action";
import { useNavigate } from "react-router-dom";
import { getEducationLevel } from "../redux/actions/educationLevel.action";
import { useLocation } from "react-router-dom";
import { imageGenerator } from "../utils/imageGenerator";
import useLoader from "../hooks/useLoader";

function RequestInfo() {
  const dispatch = useDispatch();
  const {setLoader} = useLoader();
  const { addrequestinfo_data } = useSelector((state) => state.CommonReducer);
  const navigate = useNavigate();
  const location = useLocation();
  const title = location.state?.title;
  const course = location.state?.course;
  const formRef = useRef(null);

  //----------------------------------------------------------USE EFFECT FOR GET COURSES-----------------------------------------------------------------//
  useEffect(() => {
    dispatch(getCourses());
    dispatch(getEducationLevel());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  useEffect(() => {
    if (addrequestinfo_data && addrequestinfo_data.status == 200) {
      setLoader(false);
      const message = addrequestinfo_data.data.message;
      dispatch(addReuestInfoSuccess(null));
      navigate("../thankYou", {
        state: { message: message },
      });
    }
  }, [addrequestinfo_data]);
  //----------------------------------------------------------USE EFFECT FOR GET COURSES-----------------------------------------------------------------//



  const handleSubmit = async (values, { resetForm }) => {
    const pdf = await imageGenerator(formRef.current);

    const payload = {
      firstname: values.firstName,
      lastname: values.lastName,
      email: values.email,
      phonenumber: values.phoneNumber,
      education_level_id: values.educationLevel,
      course_id: values.programOfIntrest,
      message: values.message ? values.message : "",
      pdfFile: pdf,
    };

    if (title) {
      if (values.programOfIntrest == 25) {
        window.open(
          "https://drive.google.com/file/d/17Ld7eCFKvhcuK74O0naVH6H4YOWwRGm1/view",
          "_blank",
          "noopener,noreferrer"
        );
      } else {
        window.open(
          "https://drive.google.com/file/d/1DvT2elOtTCn4m2Gbevn5u3lxiD66ZHTr/view",
          "_blank",
          "noopener,noreferrer"
        );
      }
    }

    dispatch(addReuestInfo(payload));
    setLoader(true);
    resetForm();
  };

  const iframeRef = useRef(null);
  const [count, setCount] = useState(0);
  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe && title) {
      iframe.onload = () => {
        if (count < 1) {
          setCount((n) => n + 1);
        } else if (count < 3 && count > 0) {
          if (course == "all") {
            window.open(
              "https://drive.google.com/file/d/1KPo7FC8pi6fCnkiI67PWEbLRUyfwLzHG/view",
              "_blank",
              "noopener,noreferrer"
            );
          } else if (course == "lpn") {
            window.open(
              "https://drive.google.com/file/d/1RdgzqVottg0cEJRgkO4pxcBTHFKVvw4l/view",
              "_blank",
              "noopener,noreferrer"
            );
          }

          setCount(100);
        }
      };
    }
  }, [count]);

  return (
    <div className="mb-[-40px] flex justify-center flex-col">
      {title&&<p className="text-center text-red-500 font-[500] text-[24px] mt-8 font-poppins">{title}</p>}
      <iframe
        ref={iframeRef}
        origin
        id="JotFormIFrame-231016193942048"
        title="Enrollment"
        onload="window.parent.scrollTo(0,0)"
        allowtransparency="true"
        allowfullscreen="true"
        allow="geolocation; microphone; camera"
        src="https://form.jotform.com/231016193942048?isIframeEmbed=1"
        frameborder="0"
        scrolling="no"
        className="min-w-full h-[1280px] 576:h-[1120px] "
      ></iframe>
    </div>
     );
}

export default RequestInfo;
